var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-list',{attrs:{"clients":_vm.filteredClients,"people":_vm.filteredPeopleForChat,"users":_vm.filteredUsersForChat,"groups":_vm.filteredGroupForChat,"others":_vm.others,"all":_vm.allChat,"chat-or-phone":'CHAT',"show":_vm.show}})}
var staticRenderFns = []

export { render, staticRenderFns }